<fieldset>
  <h3>{{ 'tarificateur.payement.frequency' | translate }}</h3>
  <mat-radio-group
    [formControl]="fc"
    class="is-flex is-flex-direction-column gap-s">
    <mat-radio-button class="tarif-option" [value]="1">
      <span class="is-size-6">{{ 'tarificateur.payement.frequency.yearly' | translate }} - {{ periodicity.annual | currencyFormat }}</span>
    </mat-radio-button>
    <mat-radio-button class="tarif-option" [value]="2">
      <span class="is-size-6">{{ 'tarificateur.payement.frequency.sixmonths' | translate }} - {{ periodicity.semi_annual | currencyFormat }}</span>
    </mat-radio-button>
    <mat-radio-button class="tarif-option" [value]="3">
      <span class="is-size-6">{{ 'tarificateur.payement.frequency.threemonths' | translate }} - {{ periodicity.quarterly | currencyFormat }}</span>
    </mat-radio-button>
    <mat-radio-button class="tarif-option" [value]="4">
      <span class="is-size-6">{{ 'tarificateur.payement.frequency.monthly' | translate }} - {{ periodicity.monthly | currencyFormat }}</span>
    </mat-radio-button>
  </mat-radio-group>
</fieldset>
